import React, { FC, HTMLAttributes } from 'react';
import { createUseStyles } from '../theming';
import Color from 'color';
import clsx from 'clsx';

const useStyles = createUseStyles((theme) => ({
  root: {
    height: 22,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 6,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: '0px 8px',
    fontSize: '0.75rem',
    fontWeight: 700,
  },
  error: {
    backgroundColor: Color(theme.palette.error.main).alpha(0.16).string(),
    color: theme.palette.error.main,
  },
  success: {
    backgroundColor: Color(theme.palette.success.main).alpha(0.16).string(),
    color: theme.palette.success.main,
  },
  warning: {
    backgroundColor: Color(theme.palette.warning.main).alpha(0.16).string(),
    color: theme.palette.warning.main,
  },
  info: {
    backgroundColor: Color(theme.palette.info.main).alpha(0.16).string(),
    color: theme.palette.info.main,
  },
  primary: {
    backgroundColor: Color(theme.palette.primary.main).alpha(0.16).string(),
    color: theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: Color(theme.palette.secondary.main).alpha(0.16).string(),
    color: theme.palette.secondary.main,
  },
}));

interface Props extends HTMLAttributes<HTMLElement> {
  text: string;
  color: 'success' | 'error' | 'warning' | 'info' | 'primary' | 'secondary';
}

const Badge: FC<Props> = ({ color, text, className, ...otherProps }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, classes[color], className)} {...otherProps}>
      {text}
    </div>
  );
};

export default Badge;
